// extracted by css-extract-rspack-plugin
export default {"searchContentLoader":"search-content-loader--YRFAVNfbk8RrxLXL"};